<template>
  <div class="flow-db-record-approval-form"
       v-loading="loading"
       element-loading-text="加载中...">
    <template v-if="formInfo">
      <AppScrollbar style="height: 100%">
        <div class="flow-form-container">
          <FlowCommonApprovalForm :form-info="formInfo"></FlowCommonApprovalForm>
        </div>
      </AppScrollbar>
    </template>
    <template v-else-if="!loading">
      <Hint type="error">
        <div>表单数据加载失败</div>
        <el-button size="mini" type="text" @click="loadFormInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import Hint from '../../../../../../elements/Hint'
import FlowCommonApprovalForm from '../../../../../flow/common/approval/form'

export default {
  name: 'FlowDbRecordApprovalForm',
  components: {
    AppScrollbar,
    Hint,
    FlowCommonApprovalForm
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      formInfo: null
    }
  },
  methods: {
    loadFormInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/flow/db/record/process/form',
        method: 'post',
        data: this.$qs.stringify({ id: this.id })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.formInfo = response.data.formInfo || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadFormInfo()
  }
}
</script>

<style lang="scss">
.flow-db-record-approval-form {
  height: 100%;

  .flow-form-container {
    padding: 16px;
  }
}
</style>
